import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../components/FontAwesomeIcons";

export class CreateEventStepProgress extends React.Component {
    constructor(props) {
        super(props);
    }

    getProgressPercent = _ => {
        if (!this.props.totalSteps) {
            return 0;
        }
        return Math.min(Math.round((this.props.currentStep / this.props.totalSteps) * 100), 100);
    }

    getProgressStyle = _ => {
        return {
            width: `${this.getProgressPercent()}%`,
        };
    }

    render() {
        return (
            <div className={"bg-white border-bottom shadow-sm px-3 py-3 sticky-top"}>
                <div className={"d-flex align-items-center justify-content-between mb-2"}>
                    <button
                        type={"button"}
                        className={"btn btn-link text-primary font-weight-bold p-0"}
                        onClick={this.props.onBack}
                    >
                        <FaSolidIcon name={"chevron-left"} className={"mr-1"}/>
                        Indietro
                    </button>
                    <div className={"small text-muted font-weight-bold"}>
                        Step {this.props.currentStep} di {this.props.totalSteps}
                    </div>
                </div>
                <div className={"progress"} style={this.props.progressContainerStyle}>
                    <div className={"progress-bar bg-primary"} role={"progressbar"} style={this.getProgressStyle()}/>
                </div>
            </div>
        );
    }
}

CreateEventStepProgress.propTypes = {
    currentStep: PropTypes.number,
    totalSteps: PropTypes.number,
    onBack: PropTypes.func,
    progressContainerStyle: PropTypes.object,
};
